import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en";
import it from "./locales/it";
import de from "./locales/de";
import fr from "./locales/fr";
import zh from "./locales/zh";
import es from "./locales/es";
import nl from "./locales/nl";

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      it: { translation: it },
      de: { translation: de },
      fr: { translation: fr },
      zh: { translation: zh },
      es: { translation: es },
      nl: { translation: nl },
    },
    lng: localStorage.getItem("eema_lang") || "en",
    fallbackLng: "en",
    interpolation: { escapeValue: false },
  });

export default i18n;
